
<div class="header" role="banner">
    <div class="header-brand">
        <img *ngIf="!loadingBrand && !carrierInformation?._logoFullPath" class="vertafore-logo" src="/images/sircon-logo-black.svg" alt="Sircon, a Vertafore Company" />
        <app-wait *ngIf="loadingBrand"></app-wait>
        <img *ngIf="carrierInformation?._logoFullPath" class="branded-logo" src="{{carrierInformation._logoFullPath}}}"
             alt="{{carrierInformation.carrierName}}" />
    </div>
</div>
